unit PrepareOperationItemType;

interface

uses
  SpecialismType;

type
  TPrepareOperationItemType = class
  private
    fPrepareOperationKey: String;
    fName: String;
    fSpecialism: TSpecialismType;
    fActive: Boolean;
  public
    property PrepareOperationKey: String read fPrepareOperationKey;
    property Name: String read fName;
    property Specialism: TSpecialismType read fSpecialism;
    property Active: Boolean read fActive;
  end;

implementation

end.
